<template>
  <div class="border-bg">
    <div class="border-main"></div>
    <div class="border-top"></div>
    <div class="border-right"></div>
    <div class="border-bottom"></div>
    <div class="border-left"></div>
  </div>
</template>

<script>
export default {
  name: "BorderBg",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.border-bg {
  position: absolute;
  top: 0;
  left: 0;
  padding: 1px;
  width: 100%;
  height: 100%;
  pointer-events: none;
  .border-main {
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .border-top {
    position: absolute;
    left: 0;
    top: 0;
    width: 8px;
    height: 11px;
    border-left: 2px solid rgba(0, 0, 0, 0.5);
    border-top: 2px solid rgba(0, 0, 0, 0.5);
  }

  .border-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 8px;
    height: 11px;
    border-right: 2px solid rgba(0, 0, 0, 0.5);
    border-top: 2px solid rgba(0, 0, 0, 0.5);
  }

  .border-bottom {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 8px;
    height: 11px;
    border-right: 2px solid rgba(0, 0, 0, 0.5);
    border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  }
  .border-left {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 8px;
    height: 11px;
    border-left: 2px solid rgba(0, 0, 0, 0.5);
    border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  }
}
</style>
